import { resizeImage } from '../../../helpers/resize-image';

export function Photo({ url, width=600, height=400 }) {
  return (
    <img className={`property-card__photo`} src={resizeImage({ url, width, height })} />
  );
}
